// extracted by mini-css-extract-plugin
export default {"spaceBetween":"deEdJEI"};